import axios from '@didi/dajax';
export function download(url, params) {
    return axios({
        method: 'post',
        url: url,
        data: params,
        timeout: 5 * 60 * 1000,
        // needEncrypt: true,
        responseType: 'blob',
    });
}
export function saveExportFile(fileName, response) {
    if (!response) {
        console.error('下载失败！');
    }
    var url = window.URL.createObjectURL(new Blob([response.data]));
    var link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
}
